import * as Sentry from '@sentry/browser';

import packageInfo from '../../package.json';

// This is our project dsn
const dsn = 'https://2dae3b21c538ad821edd9bce259f05dd@o354215.ingest.us.sentry.io/4508400960471040';

export const initializeSentry = () => {
  Sentry.init({
    dsn: dsn,
    tracesSampleRate: 1.0,
    environment: process.env.REACT_APP_ENV,
    release: `own-brands-landing-page@${packageInfo.version}`,
  });
  Sentry.getCurrentScope().setTag('version', packageInfo.version || 'undefined');
};

export const withSentryHub = () => {
  if (!Sentry) {
    initializeSentry();
  }
  return Sentry;
};
